import React from 'react';
import Bridge2BeginTeam from './bridge2BeginTeam';

export default function BrightBeginnings() {
  return (
    <>
      <div className='Inner-banner'>
        <img
          className="img-fluid"
          src={`${process.env.PUBLIC_URL}/img/fampy-bridge2begin.jpg`}
          alt="Home Visits"
        />
      </div>

      <div className='brightBeginnings'>
        <Bridge2BeginTeam />
      </div>
    </>
  );
}
